import DashboardStatistics from "./DashboardStatistics";
import { useTranslation } from "react-i18next";

const AdminDashboard = () => {
  const { t } = useTranslation();
  document.title = t("common.pageTitle", {
    page: t("dashboard.adminPageTitle"),
  });
  return <DashboardStatistics />;
};

export default AdminDashboard;
